export default {
  name: "layui-table-column",
  prop: {
    prop: {
      type: String
    },
    label: {
      type: String
    },
    align: {
      type: String
    },
    width: {
      type: String
    },
    minWidth: {
      type: String
    },
    labelClassName: {
      type: [String, Object, Array]
    }
  },

  render(h) {
    // slots 也要渲染，需要计算合并表头
    return h("div", this.$slots.default);
  }
};
